import { render, staticRenderFns } from "./HomeZeki.vue?vue&type=template&id=4899858c&scoped=true&"
import script from "./HomeZeki.vue?vue&type=script&lang=js&"
export * from "./HomeZeki.vue?vue&type=script&lang=js&"
import style0 from "./HomeZeki.vue?vue&type=style&index=0&id=4899858c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899858c",
  null
  
)

export default component.exports